.#{$namespace}-radio {
	--radio-size: 16px;
	--radio-font-size: #{$font-size};
	--radio-input-height: 16px;

	position: relative;
	display: inline-flex;
	align-items: center;
	margin-right: 24px;
	font-size: var(--radio-font-size);
	color: $text-secondary-color;
	font-weight: 500;
	cursor: pointer;
	user-select: none;
	white-space: nowrap;
	height: $control-height;

	&--large {
		--radio-size: 18px;
		--radio-input-height: 18px;
		height: calc(#{$control-height} + 8px);
	}

	&--small {
		--radio-size: 14px;
		--radio-input-height: 14px;
		--radio-font-size: 12px;
		height: calc(#{$control-height} - 8px);
	}

	&.is-bordered {
		padding: 0 12px;
		border: 1px solid $border-color;
		border-radius: 4px;
		box-sizing: border-box;

		&.is-checked {
			border-color: color-token(primary);
		}

		&.is-disabled {
			border-color: $border-lighter-color;
		}
	}

	&.is-disabled {
		color: $text-disabled-color;
		cursor: not-allowed;
	}
}

.#{$namespace}-radio__input {
	position: relative;
	display: inline-flex;
	white-space: nowrap;
	outline: none;
	cursor: pointer;

	&.is-disabled {
		cursor: not-allowed;
	}
}

.#{$namespace}-radio__original {
	opacity: 0;
	outline: none;
	position: absolute;
	margin: 0;
	width: 0;
	height: 0;
	z-index: -1;
}

.#{$namespace}-radio__inner {
	position: relative;
	display: inline-block;
	box-sizing: border-box;
	width: var(--radio-input-height);
	height: var(--radio-input-height);
	background-color: $white-color;
	border: 1px solid $border-color;
	border-radius: 50%;
	transition:
		border-color 0.15s,
		background-color 0.15s;

	&::after {
		content: '';
		position: absolute;
		left: 50%;
		top: 50%;
		/** 稿实心点略小于整圈六成，留一圈白边 */
		width: calc(var(--radio-input-height) * 0.55);
		height: calc(var(--radio-input-height) * 0.55);
		border-radius: 50%;
		/** 选中点和环同色；未选 scale(0)，写白会在放大时闪一块白 */
		background-color: color-token(primary);
		transform: translate(-50%, -50%) scale(0);
		transition: transform 0.15s;
	}
}

.#{$namespace}-radio__input.is-checked .#{$namespace}-radio__inner {
	/** 稿不是整圈铺主色再挖白点，是白底 + 主色环 */
	background-color: $white-color;
	border-color: color-token(primary);
	/** 1px 环太细，对不上稿上的圈 */
	border-width: 2px;

	&::after {
		transform: translate(-50%, -50%) scale(1);
	}
}

.#{$namespace}-radio__input.is-disabled .#{$namespace}-radio__inner {
	background-color: $border-lighter-color;
	border-color: $border-light-color;
	cursor: not-allowed;

	&::after {
		/** 禁用选中也是同色点，不用白点（整圈不再铺色） */
		background-color: $text-disabled-color;
	}
}

.#{$namespace}-radio__input.is-disabled.is-checked .#{$namespace}-radio__inner {
	/** 跟可用态同一套空心环，只把主色换成浅主色 */
	background-color: $white-color;
	border-color: color-token(primary, light-5);

	&::after {
		background-color: color-token(primary, light-5);
	}
}

.#{$namespace}-radio__input.is-focus .#{$namespace}-radio__inner {
	border-color: color-token(primary);
}

.#{$namespace}-radio__label {
	display: inline-block;
	padding-left: 8px;
	line-height: 1;
	font-size: var(--radio-font-size);
}

.#{$namespace}-radio-group {
	display: inline-flex;
	flex-wrap: wrap;
	align-items: center;
	font-size: $font-size;

	&.is-vertical {
		flex-direction: column;
		align-items: flex-start;

		.#{$namespace}-radio {
			margin-right: 0;
			margin-bottom: 8px;
			height: auto;
		}
	}

	&.is-horizontal {
		flex-direction: row;
	}

	.#{$namespace}-radio:last-of-type {
		margin-right: 0;
		margin-bottom: 0;
	}
}

.#{$namespace}-radio-button {
	position: relative;
	display: inline-flex;
	margin: 0;

	&--large {
		.#{$namespace}-radio-button__inner {
			padding: 10px 16px;
			font-size: $font-size;
		}
	}

	&--small {
		.#{$namespace}-radio-button__inner {
			padding: 5px 12px;
			font-size: 12px;
		}
	}

	&.is-checked {
		.#{$namespace}-radio-button__inner {
			color: $white-color;
			background-color: color-token(primary);
			border-color: color-token(primary);
			box-shadow: -1px 0 0 0 color-token(primary);
		}
	}

	&.is-disabled {
		cursor: not-allowed;

		.#{$namespace}-radio-button__inner {
			color: $text-disabled-color;
			background-color: $border-lighter-color;
			border-color: $border-light-color;
			box-shadow: none;
			cursor: not-allowed;
		}
	}

	&.is-disabled.is-checked {
		.#{$namespace}-radio-button__inner {
			color: $white-color;
			background-color: color-token(primary, light-5);
			border-color: color-token(primary, light-5);
		}
	}
}

.#{$namespace}-radio-button__original {
	opacity: 0;
	outline: none;
	position: absolute;
	margin: 0;
	z-index: -1;
}

.#{$namespace}-radio-button__inner {
	display: inline-block;
	line-height: 1;
	white-space: nowrap;
	vertical-align: middle;
	background: $white-color;
	border: 1px solid $border-color;
	border-left: 0;
	color: $text-secondary-color;
	font-size: $font-size;
	font-weight: 500;
	padding: 8px 16px;
	cursor: pointer;
	transition:
		color 0.15s,
		background-color 0.15s,
		border-color 0.15s;
}

.#{$namespace}-radio-button:first-child {
	.#{$namespace}-radio-button__inner {
		border-left: 1px solid $border-color;
		border-radius: 4px 0 0 4px;
		box-shadow: none;
	}
}

.#{$namespace}-radio-button:last-child {
	.#{$namespace}-radio-button__inner {
		border-radius: 0 4px 4px 0;
	}
}

.#{$namespace}-radio-button:first-child:last-child {
	.#{$namespace}-radio-button__inner {
		border-radius: 4px;
	}
}
